import React, { useContext, useEffect } from "react"
import Section from "@components/section"

import CommonContext from "@src/context"
import Button from "@components/button"
import ClickableImage from "@components/clickableImage"
import BottomButtons from "@components/bottomButtons"

import matchImg from "@images/season1/splatoon-duizhen.png"
import bgImage from "@images/splatoon-bg.jpg"

const Splatoon = () => {
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <Section title="比赛信息">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>比赛时间</td>
              <td>
                6月20日（周六） 14 : 00 开始 A组 淘汰赛
                <br />
                6月21日（周日） 14 : 00 开始 B组 淘汰赛
                <br />
                7月12日（周日） 16: 00 开始 决赛
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  前往虎牙直播间：660161
                </a>
              </td>
            </tr>
            <tr>
              <td>模式</td>
              <td>直播线上赛</td>
            </tr>
            <tr>
              <td>赛制</td>
              <td>真格淘汰赛</td>
            </tr>
            <tr>
              <td>比赛规则</td>
              <td>
                《Splatoon
                2》为组队比赛，需要4人组成一队报名参与，比赛规模选手人数有限，先到先得；
                <br />
                比赛采用真格Tower Control、Rainmaker、Splat
                Zones模式（抽签决定先后顺序）
                <br />
                三局两胜、全武器、全技能、全地图
              </td>
            </tr>
            <tr>
              <td>游戏版本</td>
              <td>比赛日更新的最新版本</td>
            </tr>
            <tr>
              <td>报名流程</td>
              <td>
                1. 填写赛事报名表；2. 提交后扫码加「赛事选手官方」群；3.
                关注群内赛事安排信息
              </td>
            </tr>
            <tr>
              <td>S2资格赛奖励</td>
              <td>
                A、B组冠军、亚军获得 SPARK 线上总决赛的参赛资格
                <br />
                A、B组冠军队伍加赛一局，获胜队伍将额外获得 6,000元的奖金奖励
              </td>
            </tr>
            <tr>
              <td>线上总决赛奖金</td>
              <td>
                冠军 12,000
                <br />
                亚军 6,000
                <br />
                季军 4,000
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="比赛须知">
        <div className="tips">
          <p>
            1.
            本次比赛每队可有最多拥有1名替补选手席位，初次报名时可不提交替补信息，在直播赛前主办最后确认时提交即可，开赛后不可随意更改替补选手，若由于选手缺席，可继续正常比赛，例如4v3等；
          </p>
          <p>
            2.
            如果参赛队伍迟到五分钟及以上，或因未到、提前离开等原因未参赛，则认定该队失去参赛资格，判该队对手获胜；
          </p>
          <p>
            3.
            报名截止后，将由主办方统一安排赛程抽签，抽签过程为保证公平性，将会发放到选手群里进行确认；
          </p>
          <p>
            4.
            在直播赛阶段，请大家保证自家网络流畅程度，建议开启加速器，在比赛前主办方OB会提前和对战的两只队伍测试几场网络环境，若基本稳定则将开始正式比赛场，开场后前30秒内若发生掉线问题，可重开比赛；若网络实在无法优化，那只能按照当前网络继续进行；
          </p>
          <p>
            5.
            为保证公正公平，已经在线上赛取得线下种子名额的队伍，需要以原成员参加线下比赛；
          </p>
          <p>
            6.
            不得在比赛时使用作弊、外挂等影响比赛公正结果的软件插件，一经发现并核实后将取消参赛资格及成绩；
          </p>
          <p>
            7. 参赛选手的 ID
            、头像、队伍名称、衣物、携带物品等不得含有违法国家法律法规的、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的文字、图案以及其他元素。如出现上述禁止情况，一经查证，则将取消该队伍参赛资格与比赛成绩；
          </p>
          <p>
            8.
            参赛选手不得发表违法国家法律法规、侮辱性的以及其他不得或不适合出现在赛事现场和线上直播中的言论。如出现上述禁止情况，则取消该队伍参赛资格与比赛成绩；
          </p>
          <p>9. 本次比赛，机核网拥有最终解释权。</p>
        </div>
      </Section>
      {
        <>
          <Section title="对阵表">
            <ClickableImage className="fluidImage" src={matchImg} />
          </Section>
          <BottomButtons groupHref="https://shimo.im/docs/U2slbw07tlw5sJWA/ ">
            {() => {
              return (
                <div className="enrollModal enrollModal-thinBtmPadding">
                  <p>请根据个人时间选择可参加的比赛组（不可重复报名）</p>
                  <div className="enrollList">
                    {[
                      {
                        name: "GROUP A",
                        date: "6月20日",
                        time: "14 : 00",
                        link: "http://sparkidea.mikecrm.com/cR15s9D",
                      },
                      {
                        name: "GROUP B",
                        date: "6月21日",
                        time: "14 : 00",
                        link: "http://sparkidea.mikecrm.com/C7vl3W8",
                      },
                    ].map(({ name, date, time, link }) => {
                      return (
                        <div className="enroll" key={name}>
                          <h3>{name}</h3>
                          <h2>
                            {date}
                            <br />
                            {time}
                          </h2>

                          <Button color="blue" href={link}>
                            确认报名
                          </Button>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            }}
          </BottomButtons>
        </>
      }
    </div>
  )
}

export default Splatoon
